<!-- Full screen modal overlay -->
<div class="attachment-preview-overlay">
  <div class="attachment-preview-container">
    
    <!-- Header with file name and controls -->
    <div class="preview-header">
      <div class="file-info">
        <span class="file-name">{{ fileName }}</span>
      </div>
      
      <div class="zoom-controls" *ngIf="isFileSupported()">
        <nz-button-group>
          <button nz-button nzType="default" nzSize="small" (click)="zoomOut()" [disabled]="zoomLevel <= minZoom">
            <span nz-icon nzType="minus"></span>
          </button>
          <button nz-button nzType="default" nzSize="small" (click)="resetZoom()">
            {{ (zoomLevel * 100) | number:'1.0-0' }}%
          </button>
          <button nz-button nzType="default" nzSize="small" (click)="zoomIn()" [disabled]="zoomLevel >= maxZoom">
            <span nz-icon nzType="plus"></span>
          </button>
        </nz-button-group>
      </div>

      <div class="action-buttons">
        <button nz-button nzType="default" nzSize="small" (click)="downloadFile()">
          <span nz-icon nzType="download"></span>
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="closeModal()">
          <span nz-icon nzType="close"></span>
        </button>
      </div>
    </div>

    <!-- Content area -->
    <div class="preview-content">
      
      <!-- Loading state -->
      <div class="loading-container" *ngIf="isLoading">
        <nz-spin nzSize="large">
          <div class="loading-text">Загрузка файла...</div>
        </nz-spin>
      </div>

      <!-- Error state -->
      <div class="error-container" *ngIf="error">
        <nz-result
          nzStatus="error"
          [nzTitle]="error"
          nzSubTitle="Попробуйте загрузить файл еще раз или обратитесь в поддержку">
          <div nz-result-extra>
            <button nz-button nzType="primary" (click)="loadFile()">
              Попробовать снова
            </button>
            <button nz-button (click)="downloadFile()">
              Скачать файл
            </button>
          </div>
        </nz-result>
      </div>

      <!-- PDF Preview -->
      <div class="pdf-container" *ngIf="!isLoading && !error && fileType === 'pdf' && pdfSrc">
        <pdf-viewer
          #pdfViewer
          [src]="pdfSrc"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="false"
          [zoom]="zoomLevel"
          [zoom-scale]="'page-width'"
          style="display: block; width: 100%; height: 100%;">
        </pdf-viewer>
      </div>

      <!-- Image Preview -->
      <div class="image-container" *ngIf="!isLoading && !error && fileType === 'image' && fileUrl">
        <div class="image-wrapper">
          <img 
            [src]="fileUrl" 
            [alt]="fileName"
            [style.transform]="imageTransform"
            class="preview-image">
        </div>
      </div>

      <!-- Unsupported file type -->
      <div class="unsupported-container" *ngIf="!isLoading && !error && fileType === 'unsupported'">
        <div class="unsupported-content">
          <div class="file-icon">
            <span nz-icon nzType="file" nzTheme="outline"></span>
          </div>
          <div class="unsupported-message">
            Этот формат файла не поддерживается для просмотра.
          </div>
          <button nz-button nzType="primary" nzSize="large" (click)="downloadFile()">
            <span nz-icon nzType="download"></span>
            Скачать
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
